import React from "react";
import { KULTOUR_ENABLED } from "../../config";

import AppHero from "../modules/hero";
import AppAbout from "../modules/about";
import AppBrandingBand from "../modules/brandingBand";
import AppPlayers from "../modules/players";
import AppConcerts from "../modules/concerts";
import AppAbschluss from "../modules/abschluss";
import AppKulTOUR from "../modules/kultour";
import AppContact from "../modules/contact";

function AppStart() {
  return (
    <div className="main">
      <AppHero />
      <AppAbout />
      <AppBrandingBand />
      <AppPlayers />
      <AppConcerts />
      <AppAbschluss />
      {KULTOUR_ENABLED && <AppKulTOUR />}
      <AppContact />
    </div>
  );
}

export default AppStart;
